import React from "react";

import TimeListCard from "./TimeListCard";
import "./TimeList.css";

const TimeList = (props) => {
  //const rowID = useRef(0);

  if (!props.data) {
    return (
      <div className="timelist">
        <table className="table-timelist">
          <tbody className="table-timelist__body">
            <tr>
              <td className="table-timelist__body-header-item">#</td>
              <td className="table-timelist__body-header-item"></td>
              <td className="table-timelist__body-header-item">Time</td>
              <td className="table-timelist__body-header-item">Ao5</td>
              <td className="table-timelist__body-header-item">Mo5</td>
              <td className="table-timelist__body-header-item">Mo12</td>
            </tr>
          </tbody>
        </table>
        <div className="timelist-info">
          <p>
            Welcome!  
          </p>
          <hr />
          <ul>
            <li>
              <b>Desktop shortcuts</b>
            </li>
            <li>[space]: start/stop</li>
            <li>[del]: delete most recent time</li>
            <li>[2]: 2x2</li>
            <li>[3]: 3x3</li>
            <li>[r]: reset session (delete all times)</li>
            <li>[h]: hide/unhide timer</li>
          </ul>


        </div>
      </div>
    );
  }

  // let myTimeList = null;
  // let timeData = [];
  // if (!Array.isArray(props.data)) {  //this actually never gets called now because  is always sent
  //   //https://dev.to/arikaturika/use-this-trick-to-map-over-single-objects-in-javascript-38nb
  //   myTimeList = <h4> props.data.item </h4>;
  //   timeData = [props.data.item];
  // } else {

  const elementHandler = (id) => {
    console.log("The id of this row is: " + id.target.id);
  };

  
  const tma = props.data;
  // if(!props.data.id){
  //   console.log("Conflict possibly with mmt2024 project - delete 'data' in Local Storage")
  //   return;
  // }

  // Fastest Time
  let currMin = 99999999999;
  let currMinIndex = -1;
  for (let i = 0; i < tma.length; i++) {
    let tm = tma[i].item ;

    if (tm < currMin && !tma[i].dnf) {
      currMin = tma[i].item;
      currMinIndex = tma[i].id;
    }
  }

  // Slowest Time
  let currMax = -1;
  let currMaxIndex = -1;
  for (let i = 0; i < tma.length; i++) {
    let tm = tma[i].item ;

    if (tm > currMax) {
      currMax = tma[i].item;
      currMaxIndex = tma[i].id;
    }
  }  

  // Get WCA Average of 5
  const wcaFive = (xa) => {
    let dnfCount = 0,
      sortedX = [];
    for (let i = 0; i < 5; i++) {
      if (xa[i].dnf) {
        sortedX.push(86400);
        dnfCount++;
      } else {
        sortedX.push(xa[i].item + (xa[i].penalty ? 2 : 0));
      }
    }
    // console.log(sortedX)
    if (dnfCount < 2) {
      sortedX.sort(function (a, b) {
        return a - b;
      });
      let ao5 = (sortedX[1] + sortedX[2] + sortedX[3]) / 3;
      // console.log(ao5)
      return +ao5;
    }
    if (dnfCount >= 2) {
      return "dnf";
    }
  };

  // // 5-Period Moving Average (including Ao5) OLD
  // let ma5Min = 99999999999;
  // let ma5Index = -1;
  // let ao5Min = 99999999999;
  // let ao5Index = -1;
  // for (let i = tma.length - 1; i >= 0; i--) {
  //   let n = 0,
  //     sum = 0;
  //   let ma5 = 0;

  //   if (i < tma.length - 4) {
  //     //MA(5) requires this at least
  //     // sum =
  //     //   tma[i].item +
  //     //   tma[i + 1].item +
  //     //   tma[i + 2].item +
  //     //   tma[i + 3].item +
  //     //   tma[i + 4].item;
  //     //let tm = tma[i].item + (tma[i].penalty ? 2 : 0);

  //     if (!tma[i].dnf) {
  //       sum += tma[i].item + (tma[i].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 1].dnf) {
  //       sum += tma[i + 1].item + (tma[i + 1].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 2].dnf) {
  //       sum += tma[i + 2].item + (tma[i + 2].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 3].dnf) {
  //       sum += tma[i + 3].item + (tma[i + 3].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 4].dnf) {
  //       sum += tma[i + 4].item + (tma[i + 4].penalty ? 2 : 0);
  //       n += 1;
  //     }

  //     ma5 = sum / n;
  //     if (n !== 5) {
  //       ma5 = -1;
  //     }
  //     tma[i]["ma5"] = ma5; //adds new key/value pair to object[i]

  //     if (ma5 < ma5Min && !tma[i].dnf && ma5 > 0) {
  //       ma5Min = ma5;
  //       ma5Index = tma[i].id;
  //     }

  //     let ao5 = wcaFive([
  //       tma[i],
  //       tma[i + 1],
  //       tma[i + 2],
  //       tma[i + 3],
  //       tma[i + 4],
  //     ]);
  //     tma[i]["ao5"] = ao5; //adds new key/value pair to object[i]
  //     if(ao5 !== "dnf"){
  //       if (ao5 < ao5Min && ao5 > 0) {
  //         ao5Min = ao5;
  //         ao5Index = tma[i].id;
  //       }
  //     }

  //   } else {
  //     tma[i]["ao5"] = -1; //adds new key/value pair to object[i]
  //     tma[i]["ma5"] = -1; //adds new key/value pair to object[i]
  //   }
  // }

  

  // 5-Period Moving Average (including Ao5; no penalty or dnf logic) 
  let ma5Min = 99999999999;
  let ma5Index = -1;
  let ao5Min = 99999999999;
  let ao5Index = -1;
  for (let i = tma.length - 1; i >= 0; i--) {
    let sum = 0;
    let ma5 = 0;
    if (i < tma.length - 4) {
      sum = tma[i].item + tma[i+1].item + tma[i+2].item + tma[i+3].item + tma[i+4].item 
      ma5 = sum / 5;

      tma[i]["ma5"] = ma5; //adds new key/value pair to object[i]
      if (ma5 < ma5Min && ma5 > 0) {
        ma5Min = ma5;
        ma5Index = tma[i].id;
      }

      let ao5 = wcaFive([
        tma[i],
        tma[i + 1],
        tma[i + 2],
        tma[i + 3],
        tma[i + 4],
      ]);
      tma[i]["ao5"] = ao5; //adds new key/value pair to object[i]
      if (ao5 < ao5Min && ao5 > 0) {
        ao5Min = ao5;
        ao5Index = tma[i].id;
      }
    } else {
      tma[i]["ma5"] = -1; //adds new key/value pair to object[i]
      tma[i]["ao5"] = -1; //adds new key/value pair to object[i]
    }
  }
  


  // 12-Period Moving Average  (no penalty or dnf logic)
  let ma12Min = 99999999999;
  let ma12Index = -1;
  for (let i = tma.length - 1; i >= 0; i--) {
    let sum = 0;
    let ma12 = 0;
    if (i < tma.length - 11) {
      sum = tma[i].item + tma[i+1].item + tma[i+2].item + tma[i+3].item + tma[i+4].item + 
      tma[i+5].item + tma[i+6].item + tma[i+7].item + tma[i+8].item + tma[i+9].item + 
      tma[i+10].item + tma[i+11].item;
      ma12 = sum / 12;

      tma[i]["ma12"] = ma12; //adds new key/value pair to object[i]
      if (ma12 < ma12Min && ma12 > 0) {
        ma12Min = ma12;
        ma12Index = tma[i].id;
      }
    } else {
      tma[i]["ma12"] = -1; //adds new key/value pair to object[i]
    }
  }


  // EXPERIMENTAL %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  const lenx = 20
  for (let i = tma.length - 1; i >= 0; i--) {
    if (i < tma.length - (lenx-1)) {
      const tma20 = tma.slice(i,i+lenx)
      const items = Object.keys(tma20).map(key => tma20[key].item);
      const ma20 = items.reduce((x,y)=>x+y,0) / lenx
      tma[i]["ma20"] = ma20; //adds new key/value pair to object[i]
      //console.log(i + " " + tma20.length + " " + ma20)
      //console.log(items)
    } else {
      tma[i]["ma20"] = -1; //adds new key/value pair to object[i]
    }
  }
  // let tma20 = tma.slice(0,20)
  // if(tma20.length == 20){
  //   const items = Object.keys(tma20).map(key => tma20[key].item);
  //   const ma20 = items.reduce((x,y)=>x+y,0) / 20  // but where to put this???   
  // }
  
  

  // OLD
  // 12-Period Moving Average  
  // for (let i = tma.length - 1; i >= 0; i--) {
  //   let n = 0;
  //   let sum = 0;
  //   let ma12 = 0;
  //   if (i < tma.length - 11) {
  //     if (!tma[i].dnf) {
  //       sum += tma[i].item + (tma[i].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 1].dnf) {
  //       sum += tma[i + 1].item + (tma[i + 1].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 2].dnf) {
  //       sum += tma[i + 2].item + (tma[i + 2].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 3].dnf) {
  //       sum += tma[i + 3].item + (tma[i + 3].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 4].dnf) {
  //       sum += tma[i + 4].item + (tma[i + 4].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 5].dnf) {
  //       sum += tma[i + 5].item + (tma[i + 5].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 6].dnf) {
  //       sum += tma[i + 6].item + (tma[i + 6].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 7].dnf) {
  //       sum += tma[i + 7].item + (tma[i + 7].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 8].dnf) {
  //       sum += tma[i + 8].item + (tma[i + 8].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 9].dnf) {
  //       sum += tma[i + 9].item + (tma[i + 9].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 10].dnf) {
  //       sum += tma[i + 10].item + (tma[i + 10].penalty ? 2 : 0);
  //       n += 1;
  //     }
  //     if (!tma[i + 11].dnf) {
  //       sum += tma[i + 11].item + (tma[i + 11].penalty ? 2 : 0);
  //       n += 1;
  //     }

  //     ma12 = sum / n;
  //     if (n !== 12) {
  //       ma12 = -1;
  //     }
  //     tma[i]["ma12"] = ma12; //adds new key/value pair to object[i]
  //     if (ma12 < ma12Min && !tma[i].dnf && ma12 > 0) {
  //       ma12Min = ma12;
  //       ma12Index = tma[i].id;
  //     }
  //   } else {
  //     tma[i]["ma12"] = -1; //adds new key/value pair to object[i]
  //   }
  // }


//  const tableRows = <tr><td>test</td></tr>

  const tableRows = tma.map((element, index, array) => {

    let td0Class = "table-timelist__row-item";
 
    if (element.id === currMaxIndex) {
      td0Class = "table-timelist__row-item-highlight-max";
    }    
    if (element.id === currMinIndex) {
      td0Class = "table-timelist__row-item-highlight-min";
    }    



    //Styling for average of 5
    let td5aClass = "table-timelist__row-item";
    if (element.id === ao5Index) {
      td5aClass = "table-timelist__row-item-highlight-min";
    }

    //Styling for mean of 5
    let td5Class = "table-timelist__row-item";
    if (element.id === ma5Index) {
      td5Class = "table-timelist__row-item-highlight-min";
    }

    //Styling for mean of 12
    let td12Class = "table-timelist__row-item";
    if (element.id === ma12Index) {
      td12Class = "table-timelist__row-item-highlight-min";
    }


    const cssEmpty = "table-timelist__row-item-flex_empty"
    let cssTop5 = cssEmpty
    if(element.top5 === true){
      cssTop5 = "table-timelist__row-item-flex_top5"
    }
    let cssTop10 = cssEmpty
    if(element.top10 === true){
      cssTop10 = "table-timelist__row-item-flex_top10"
    }
    let cssOutlier = cssEmpty
    if(element.outlier === true){
      cssOutlier = "table-timelist__row-item-flex_outlier"
    }
    let cssTarget = cssEmpty
    if(element.met_target === true){
      cssTarget = "table-timelist__row-item-flex_target"
    }
    

    let idClass = "table-timelist__row-id"
    let item = element.item
    let target = element.target
    if(index < tma.length-1){
      target = array[index+1]['target']
      if(item < target){
        idClass = idClass + " target-met"
      }
    }




    
    

    return (
      <tr
        id={element.id}
        key={element.key}
        onClick={elementHandler}
        className="table-timelist__row"
      >
        <td id={element.id} className={idClass}>
          {element.idpx}
        </td>

        <td className="table-timelist__row-item-flex">
          <div className={cssTop5}>&nbsp;</div>
          <div className={cssTop10}>&nbsp;</div>
          <div className={cssEmpty}>&nbsp;</div>
          <div className={cssOutlier}>&nbsp;</div>
          <div className={cssTarget}>&nbsp;</div>
        </td>

        <td className={td0Class}>
        <TimeListCard id={element.id} tmSeconds={element.item}></TimeListCard>
        </td>

        <td className={td5aClass}>
          <TimeListCard id={element.id} tmSeconds={element.ao5} />
        </td>

        <td className={td5Class}>
          <TimeListCard id={element.id} tmSeconds={element.ma5}></TimeListCard>
        </td>

        <td className={td12Class}>
          <TimeListCard id={element.id} tmSeconds={element.ma12}></TimeListCard>
        </td>
      </tr>
    );
  });

//  console.log(tma)
  // const timeData = props.data.map((element) => parseFloat(element.item));

  return (
    <div className="timelist">
      <table className="table-timelist">
        <tbody className="table-timelist__body">
          <tr>
            <td className="table-timelist__body-header-item">#</td>
            <td className="table-timelist__body-header-item-narrow"></td>
            <td className="table-timelist__body-header-item">Time</td>
            <td className="table-timelist__body-header-item">Ao5</td>
            <td className="table-timelist__body-header-item">Mo5</td>
            <td className="table-timelist__body-header-item">Mo12</td>
          </tr>
          {tableRows}
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(TimeList);
// export default TimeList
